import { render, staticRenderFns } from "./RelatedArticles.vue?vue&type=template&id=285c99be&scoped=true&"
import script from "./RelatedArticles.vue?vue&type=script&lang=js&"
export * from "./RelatedArticles.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticles.vue?vue&type=style&index=0&id=285c99be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c99be",
  null
  
)

export default component.exports